var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ServerButton',{attrs:{"isHome":""}}),_c('div',{staticClass:"separator"}),_c('ServerButton',{attrs:{"selected":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }